import {
	type BondRequestBondType,
	ContractBondSubtype,
	ContractSuretyType,
	isContractCategoryBondType,
	isContractSuretyBondType,
} from "@inrev/common";
import { Option } from "@inrev/core";

export const resolveContractSuretyType = (
	bondType: Option<BondRequestBondType>,
	contractBondSubtype: Option<ContractBondSubtype>,
): ContractSuretyType | undefined => {
	if (Option.isNone(bondType)) return undefined;
	if (isContractSuretyBondType(bondType)) {
		return bondType;
	}
	if (isContractCategoryBondType(bondType) && Option.isSome(contractBondSubtype)) {
		switch (contractBondSubtype) {
			case ContractBondSubtype.bid:
				return ContractSuretyType.bid;
			case ContractBondSubtype.final:
				return ContractSuretyType.final;
		}
	}
	return undefined;
};
